import React, { useState, useEffect } from "react";
import { Button, Row, Col } from 'react-bootstrap'
import AuthService from "../controllers/AuthService";
import UserService from "../controllers/UserService";


const CardHomeroom = props => {

    const [items, setItems] = useState([]);
    const [data, setData] = useState( AuthService.getCurrentUser() );
    useEffect(() => {

        var filterTemp = {
            page: 0,
            category: '',
            sort: '',
            roomId: data.room.id
        };

        if (props.random) {
            var filterTemp = { random: 1 }

        } else {
            if (props.category) {
                filterTemp.category = props.category;
            };

            if (props.page) {
                filterTemp.page = props.page - 1;
            };

            if (props.sort) {
                filterTemp.sort = props.sort;
            };

            if (props.roomId) {
                filterTemp.roomId = props.roomId;
            };
        }

        UserService.getTopics(filterTemp).then((res) => {
            const items = []
            // console.log('getTopics')
            // console.log(res)

            for (const [index, value] of res.data.data.entries()) {
                // console.log('value')
                // console.log(value)
                var shortTilte = value.title;

                if (value.title.length > 100) {
                    shortTilte = shortTilte.substring(0, 97) + " ...";
                }
                const dateTemp = Array.isArray(value.createdAt) ? new Date(value.createdAt[0], value.createdAt[1] - 1, value.createdAt[2]) : null;
                const temp = {
                    // attenders: (value.attenders) ? value.attenders.length : 0,
                    usageCount: value.usageCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                    category_name: value.category,
                    // activityId: value.id,
                    topicId: value.id,
                    title: shortTilte,
                    created_at: dateTemp ? convertDate(dateTemp, 'datestring') : '-',
                    image_path: value.imageUrl
                };
                items.push(temp);
            }
            setItems(items)
            // console.log(items)
        });
    }, [props])

    function convertDate(dateTime, formatDate = 'mobile') {

        var formattedDate = ('0' + dateTime.getDate()).slice(-2);
        var formattedMonth = ('0' + (dateTime.getMonth() + 1)).slice(-2);
        // Combine and format date string
        if (formatDate === 'mobile') {
            var formattedYear = dateTime.getFullYear().toString().substr(2, 2);
            return formattedMonth + '/' + formattedDate + '/' + formattedYear;
        } else if (formatDate === 'desktop') {
            return formattedMonth + '/' + formattedDate + '/' + dateTime.getFullYear().toString();
        } else if (formatDate === 'iso') {
            return dateTime.toISOString();
        } else if (formatDate === 'datestring') {
            var months_th = ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม",];
            var temp = dateTime.getFullYear() + 543;
            return dateTime.getDate() + ' ' + months_th[dateTime.getMonth()] + ' ' + temp;
        }

        return '';
    }

    return (

        <div className="active-activity pt-3 mb-5">
            { items.map((item, index) => (
                <a href={`/topic/${item.topicId}`}>
                    <Col key={index} className="border-radius-125">
                        <Row className="mx-auto mt-3 mb-4 border-sd bg-white border-radius-125">
                            <Col xs={12} lg={4} className="p-0">
                                {/* <img src={item.image_path} className="w-100 card-img-left" /> */}
                                <div className="card-image card-img-left" style={{ "backgroundImage": `url(${item.image_path})` }}>

                                </div>
                            </Col>
                            <Col xs={12} lg={8} className="py-3 py-lg-1 px-4 card-homeroom" style={{ "alignSelf": "center" }}>
                                <Row >
                                    <Col xs={12} lg={9} style={{ "flex": '1' }}>
                                        <div className="text-left"><h3 className="font-sarabun-bold">{item.title}</h3></div>
                                        <div className="pageview grey-text text-left mt-4">
                                            <span className="font-sarabun-bold">{item.category_name}</span>

                                            {props.hideDate !== '1' && (
                                                <span className="font-sarabun"><br />
                                                    {item.created_at} | ถูกใช้งาน : {item.usageCount} ครั้ง</span>                                                
                                            )}

                                        </div>
                                    </Col>

                                    <Col xs={12} lg={3} className="px-0 d-none d-lg-inline" style={{ "flex": '1' }}>
                                        <Button className="bluesky d-inline py-1 py-1 py-lg-2 px-5 bt font-sarabun-bold" href={`/topic/${item.topicId}`} >เลือก</Button>
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={12} className="px-3 pb-3 d-inline d-lg-none">
                                <Button className="bluesky d-inline py-1 py-1 py-lg-2 btn font-sarabun-bold" href={`/topic/${item.topicId}`} >เลือก</Button>
                            </Col>
                        </Row >
                    </Col >
                </a>
            ))}

        </div >


    )
}

export default CardHomeroom


